class MainConfig {
    static readonly WARNING_PAYMENT_DATE = 27
    static readonly ENABLE_WEBSOCKET = true
    static readonly ENABLE_WEB_NOTIFICATION = false
    static readonly ENABLE_CHAT_REPLY = true
    static readonly ENABLE_CHAT_REACTION = false
    static readonly ENABLE_CHAT_PRIVATE_TAG = false
}

export default MainConfig



// WEBPACK FOOTER //
// ./src/config/main.ts